// Brand kit a průvodce po založení firmy (docs/PLAN.md 5.1).
import type { BrandKit, BrandKitInput, OnboardingStatus, ServiceItem } from '@wac-buddy/shared'
import { api } from './client'

export function getBrandKit(): Promise<BrandKit> {
  return api<BrandKit>('/org/brand-kit')
}

export function putBrandKit(input: BrandKitInput): Promise<BrandKit> {
  return api<BrandKit>('/org/brand-kit', { method: 'PUT', body: JSON.stringify(input) })
}

export async function getBrandTemplate(): Promise<ServiceItem[]> {
  return (await api<{ data: ServiceItem[] }>('/org/brand-kit/template')).data
}

export function completeOnboarding(): Promise<void> {
  return api<void>('/onboarding/complete', { method: 'POST' })
}

export function getOnboarding(): Promise<OnboardingStatus> {
  return api<OnboardingStatus>('/onboarding')
}

export function dismissOnboardingCard(): Promise<void> {
  return api<void>('/onboarding/dismiss', { method: 'POST' })
}
